import React, { Suspense } from 'react';
import FluidFinder from '../components/fluidFinder/FluidFinder';
import { isProdEnvirnoment } from '../utility/Helper';
import { NotFound } from '../components/notFound/NotFound';
import MainSkeleton from '../components/MainSkeleton';

function FluidFinderRoute() {
    return <Suspense fallback={<MainSkeleton />}>{isProdEnvirnoment() ? <NotFound /> : <FluidFinder />}</Suspense>;
}

export default React.memo(FluidFinderRoute);
